export class ResumenPedidoDto {
    public pedidoId: number = 0;
    public referencia: string = "";
    public costePedido: number = 0;
    public totalUnidades: number = 0;
    public unidadesVendidas: number = 0;
    public unidadesRestantes: number = 0;
    public mermaRoto: number = 0;
    public devoluciones: number = 0;
    public reparaciones: number = 0;
    public reservados: number = 0;
    public envio: number = 0;
    public ingresos: number = 0;
    public costeVendido: number = 0;
    public costeRestante: number = 0;
    public gananciaBruta: number = 0;
    public roiPorcentaje: number = 0;
    public porcentajeLiquidado: number = 0;
    constructor(data?: any) {
        if (!data) { return; }
        this.pedidoId            = num(data.PedidoId,            data.pedidoId);
        this.referencia          = data.Referencia          || data.referencia          || "";
        this.costePedido         = num(data.CostePedido,         data.costePedido);
        this.totalUnidades       = num(data.TotalUnidades,       data.totalUnidades);
        this.unidadesVendidas    = num(data.UnidadesVendidas,    data.unidadesVendidas);
        this.unidadesRestantes   = num(data.UnidadesRestantes,   data.unidadesRestantes);
        this.mermaRoto           = num(data.MermaRoto,           data.mermaRoto);
        this.devoluciones        = num(data.Devoluciones,        data.devoluciones);
        this.reparaciones        = num(data.Reparaciones,        data.reparaciones);
        this.reservados          = num(data.Reservados,          data.reservados);
        this.envio               = num(data.Envio,               data.envio);
        this.ingresos            = num(data.Ingresos,            data.ingresos);
        this.costeVendido        = num(data.CosteVendido,        data.costeVendido);
        this.costeRestante       = num(data.CosteRestante,       data.costeRestante);
        this.gananciaBruta       = num(data.GananciaBruta,       data.gananciaBruta);
        this.roiPorcentaje       = num(data.RoiPorcentaje,       data.roiPorcentaje);
        this.porcentajeLiquidado = num(data.PorcentajeLiquidado, data.porcentajeLiquidado);
    }
}

export class EvolucionDiariaDto {
    public fecha: string = "";
    public ingresos: number = 0;
    public coste: number = 0;
    public ganancia: number = 0;
    public roi: number = 0;
    public ticketMedio: number = 0;
    public unidades: number = 0;
    constructor(data?: any) {
        if (!data) { return; }
        this.fecha       = data.Fecha       || data.fecha       || "";
        this.ingresos    = num(data.Ingresos,    data.ingresos);
        this.coste       = num(data.Coste,       data.coste);
        this.ganancia    = num(data.Ganancia,    data.ganancia);
        this.roi         = num(data.Roi,         data.roi);
        this.ticketMedio = num(data.TicketMedio, data.ticketMedio);
        this.unidades    = num(data.Unidades,    data.unidades);
    }
}

export class KvDto {
    public key: string = "";
    public value: number = 0;
    constructor(data?: any) {
        if (!data) { return; }
        this.key   = data.Key   || data.key   || "";
        this.value = data.Value || data.value || 0;
    }
}

export class ProductoTopDto {
    public descripcion: string = "";
    public asin: string = "";
    public unidades: number = 0;
    constructor(data?: any) {
        if (!data) { return; }
        this.descripcion = data.Descripcion || data.descripcion || "";
        this.asin        = data.Asin        || data.asin        || "";
        this.unidades    = data.Unidades    || data.unidades    || 0;
    }
}

function num(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export class DashboardStatsDto {
    // Ventas — filtradas por período
    public totalUnidades: number = 0;
    public totalIngresos: number = 0;
    public costeVentas: number = 0;
    public gananciaBruta: number = 0;
    public roiPorcentaje: number = 0;
    public ticketMedio: number = 0;
    public margenMedio: number = 0;

    // Stock actual
    public unidadesStock: number = 0;
    public costeStock: number = 0;
    public retailCompra: number = 0;
    public retailHoy: number = 0;
    public revalorizacionPct: number = 0;
    public precioMedioStock: number = 0;
    public costePedidos: number = 0;
    public porcentajePagado: number = 0;

    // Estado de productos
    public reservados: number = 0;
    public mermaRoto: number = 0;
    public costeMermaRoto: number = 0;
    public reparacion: number = 0;
    public envio: number = 0;
    public precioVentaEnvio: number = 0;
    public pendientePago: number = 0;
    public devoluciones: number = 0;

    // Series para gráficas
    public ventasPorFecha: KvDto[] = [];
    public recuentoPorCondicion: KvDto[] = [];
    public rentabilidadCajas: KvDto[] = [];
    public ventasPorCategoria: KvDto[] = [];
    public inventarioEstados: KvDto[] = [];
    public topVendidos: ProductoTopDto[] = [];
    public evolucionTemporal: EvolucionDiariaDto[] = [];
    public resumenPorPedido: ResumenPedidoDto[] = [];

    constructor(data?: any) {
        if (!data) { return; }
        // Acepta tanto PascalCase (backend .NET) como camelCase
        this.totalUnidades     = num(data.TotalUnidades,     data.totalUnidades);
        this.totalIngresos     = num(data.TotalIngresos,     data.totalIngresos);
        this.costeVentas       = num(data.CosteVentas,       data.costeVentas);
        this.gananciaBruta     = num(data.GananciaBruta,     data.gananciaBruta);
        this.roiPorcentaje     = num(data.RoiPorcentaje,     data.roiPorcentaje);
        this.ticketMedio       = num(data.TicketMedio,       data.ticketMedio);
        this.margenMedio       = num(data.MargenMedio,       data.margenMedio);
        this.unidadesStock     = num(data.UnidadesStock,     data.unidadesStock);
        this.costeStock        = num(data.CosteStock,        data.costeStock);
        this.retailCompra      = num(data.RetailCompra,      data.retailCompra);
        this.retailHoy         = num(data.RetailHoy,         data.retailHoy);
        this.revalorizacionPct = num(data.RevalorizacionPct, data.revalorizacionPct);
        this.precioMedioStock  = num(data.PrecioMedioStock,  data.precioMedioStock);
        this.costePedidos      = num(data.CostePedidos,      data.costePedidos);
        this.porcentajePagado  = num(data.PorcentajePagado,  data.porcentajePagado);
        this.reservados        = num(data.Reservados,        data.reservados);
        this.mermaRoto         = num(data.MermaRoto,         data.mermaRoto);
        this.costeMermaRoto    = num(data.CosteMermaRoto,    data.costeMermaRoto);
        this.reparacion        = num(data.Reparacion,        data.reparacion);
        this.envio             = num(data.Envio,             data.envio);
        this.precioVentaEnvio  = num(data.PrecioVentaEnvio,  data.precioVentaEnvio);
        this.pendientePago     = num(data.PendientePago,     data.pendientePago);
        this.devoluciones      = num(data.Devoluciones,      data.devoluciones);

        const arr = (raw: any) => Array.isArray(raw) ? raw : [];
        this.ventasPorFecha       = arr(data.VentasPorFecha       || data.ventasPorFecha      ).map((x: any) => new KvDto(x));
        this.recuentoPorCondicion = arr(data.RecuentoPorCondicion  || data.recuentoPorCondicion).map((x: any) => new KvDto(x));
        this.rentabilidadCajas    = arr(data.RentabilidadCajas     || data.rentabilidadCajas   ).map((x: any) => new KvDto(x));
        this.ventasPorCategoria   = arr(data.VentasPorCategoria    || data.ventasPorCategoria  ).map((x: any) => new KvDto(x));
        this.inventarioEstados    = arr(data.InventarioEstados     || data.inventarioEstados   ).map((x: any) => new KvDto(x));
        this.topVendidos          = arr(data.TopVendidos           || data.topVendidos         ).map((x: any) => new ProductoTopDto(x));
        this.evolucionTemporal    = arr(data.EvolucionTemporal     || data.evolucionTemporal   ).map((x: any) => new EvolucionDiariaDto(x));
        this.resumenPorPedido     = arr(data.ResumenPorPedido      || data.resumenPorPedido    ).map((x: any) => new ResumenPedidoDto(x));
    }
}
